
<template>
  
<v-layout row wrap>
  <v-flex xs12>
    <v-card
    class="pa-3 map"  elevation-1
    >


    <Gmap-Map style="width: 100%; height: 300px;" :zoom="14" :center="center"  ref="map">
      <Gmap-Marker
        v-for="marker in allRelated"
        :key="marker.location.place_id"
        :position="marker.location.geometry.location"
        :clickable="true" 
        :draggable="false"
        @click="marker.opened = !marker.opened"
        >
           <gmap-info-window :opened="marker.opened" ><h6>{{marker.title}}</h6>
                <img :src="marker.mainImg[0].url" alt="" height="60px">
                <v-divider></v-divider>
                <p>{{marker.description}}</p>
           </gmap-info-window>
        
        </Gmap-Marker>
    </Gmap-Map>
    </v-card>
</v-flex>
  </v-layout>
 

</template>

<script>
export default {
  data() {
    return {
      relatedArtefacts: [],
      allRelated: [],
      place: {
        formatted_address: "Add a location or drag marker."
      }
    };
  },
  props:['groupTitle'],
  methods: {
    addRelatedArtefacts() {
      var i = 0;
      for (i in this.related) {
        this.relatedArtefacts.push(
          this.$store.getters.loadRelatedArtefacts(this.related[i].title)
        );
      }
      var j = 0,
        k = 0,
        z = 0;
      for (k = 0; k <= i; k++)
        for (j = 0; j < this.relatedArtefacts[k].length; j++)
          this.allRelated.push(this.relatedArtefacts[k][j]);

      this.allRelated = this.allRelated.filter(
        (allRelated, index, self) =>
          self.findIndex(
            t =>
              t.title === allRelated.title ||
              t.description === allRelated.description
          ) === index
      );
    }
  },
  update() {
    this.$refs.map.resize();
  },
  computed: {
    related() {
      return this.$store.getters.loadRelatedCollections(
        this.groupTitle
      );
    },
    center() {
      return this.allRelated[0].location.geometry.location;
    }
  },
  created() {
    this.addRelatedArtefacts();
  }
};
</script>


<style>
.toolbar__content {
  width: -webkit-fill-available !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Partials/PresentMultipleLocationsGroups.vue